import type { RootState } from '@core/redux/interface';
import type { AppDispatch } from '@core/redux/store';
import { viewer3dActions, viewer3dSelectors } from '@viewer3D/redux';
import { connect } from 'react-redux';
import type { MapDispatchToProps, MapStateToProps } from './types';

const mapStateToProps = (state: RootState): MapStateToProps => ({
  cameraViewport: viewer3dSelectors.cameraViewport(state),
  goTo: viewer3dSelectors.cameraGoto(state),
});

const mapDispatchToProps = (dispatch: AppDispatch): MapDispatchToProps => ({
  setCameraViewport: (viewport) => dispatch(viewer3dActions.setCameraViewport(viewport)),
  setGoto: (goTo) => dispatch(viewer3dActions.cameraGoto(goTo)),
});

export const connectComponent = connect(mapStateToProps, mapDispatchToProps);
